import React from "react";
import BreadCrumb from "./Title/Title";
import InputField from "../../framework/InputField/InputField";
import "./create-campaigns.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AddCampaign from "./AddCampaign/AddCampaign";
import Button from "../../framework/Button/Button";
import AcquireWebComponent from "../../framework/MaterialUI";
import { FullRow, Row, Col } from "../../framework/Grid";
import Dialog from "material-ui/Dialog";
import Checkbox from "material-ui/Checkbox";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import {
  getTimezoneMoment,
  initMomentTimezone,
  splitNumber,
  formatMoney,
  downLoadCSVFunc,
  pdfReportHeaderDataUri,
  addPdfFooter /*, getTextSize*/,
} from "../../../utils/utility";
import CampaignDetail from "./CampaignDetail";
import moment from "moment-timezone/moment-timezone";
const pdfConverter = require("jspdf");
const html2canvas = require("html2canvas");

import map from "lodash/map";
import flatMap from "lodash/flatMap";
import union from "lodash/union";
import isEmpty from "lodash/isEmpty";
import filter from "lodash/filter";
import isEqual from "lodash/isEqual";
import find from "lodash/find";
import remove from "lodash/remove";

class CreateCampaigns extends AcquireWebComponent {
  constructor(props) {
    super(props);
    initMomentTimezone();
    if (props.client_tz) {
      moment.tz.setDefault(props.client_tz);
    }
    if (props.campaignDetail) {
      const { campaignDetail } = props;
      const selectEmailCampaigns = filter(
        campaignDetail.channelCampaigns,
        campaign => {
          return campaign.channel === "Email";
        },
      );
      const selectSocialCampaigns = filter(
        campaignDetail.channelCampaigns,
        campaign => {
          return campaign.channel === "SOCIAL";
        },
      );
      const selectDisplayCampaigns = filter(
        campaignDetail.channelCampaigns,
        campaign => {
          return campaign.channel === "Display";
        },
      );

      this.state = {
        campaignId: campaignDetail.id,
        awCampaignId: campaignDetail.campaignId,
        groupCampaignType: campaignDetail.type,
        startDate: moment(campaignDetail.startDate),
        compareStartDate: moment(campaignDetail.startDate),
        minStartDate: moment(campaignDetail.startDate).subtract(15, "d"),
        endDate: moment(campaignDetail.endDate),
        compareEndDate: moment(campaignDetail.endDate),
        campaignName: campaignDetail.name,
        audienceSize: campaignDetail.audienceSize,
        campaignBudget: campaignDetail.budget,
        clientCampaignId: campaignDetail.clientCampaignId,
        selectEmailCampaigns: selectEmailCampaigns,
        selectSocialCampaigns: selectSocialCampaigns,
        selectDisplayCampaigns: selectDisplayCampaigns,
        sltEmailChannelCampaigns: map(selectEmailCampaigns, "id"),
        sltSocialChannelCampaigns: map(selectSocialCampaigns, "id"),
        sltDisplayChannelCampaigns: map(selectDisplayCampaigns, "id"),
        inEdit: false,
        editMode: true,
        onCsvReportDownload: false,
        onPdfReportDownload: false,
        showDownloadDialog: false,
        emailDeployCampaigns: campaignDetail.emailDeployments,
        socialDeployCampaigns: campaignDetail.socialDeployments,
        displayDeployCampaigns: campaignDetail.displayDeployments,
        emailReportDelivered: campaignDetail.emailReportDelivered,
        emailReportDistinctIndividuals:
          campaignDetail.emailReportDistinctIndividuals,
      };
    } else {
      this.state = {
        //startDate: props.client_tz ? moment().tz(props.client_tz) : moment(),
        //endDate: props.client_tz ? moment().add(31, 'days').tz(props.client_tz) : moment().add(31, 'days'),
        //compareStartDate: props.client_tz ? moment().tz(props.client_tz) : moment(),
        //compareEndDate: props.client_tz ? moment().add(31, 'days').tz(props.client_tz) : moment().add(31, 'days'),
        groupCampaignType: "General",
        startDate: moment(),
        endDate: moment().add(31, "days"),
        compareStartDate: moment(),
        minStartDate: moment().subtract(15, "d"),
        compareEndDate: moment().add(31, "days"),
        sltEmailChannelCampaigns: [],
        sltSocialChannelCampaigns: [],
        sltDisplayChannelCampaigns: [],
        selectEmailCampaigns: [],
        selectSocialCampaigns: [],
        selectDisplayCampaigns: [],
        campaignName: "",
        audienceSize: "",
        campaignBudget: "",
        clientCampaignId: "",
        campaignId: null,
        inEdit: true,
        editMode: false,
        onCsvReportDownload: false,
        onPdfReportDownload: false,
        showDownloadDialog: false,
        emailDeployCampaigns: [],
        socialDeployCampaigns: [],
        displayDeployCampaigns: [],
        emailReportDelivered: true,
        emailReportDistinctIndividuals: undefined,
      };
    }
  }

  handleGroupCampaignTypeChange(e, value) {
    e.preventDefault();
    this.setState({
      ...this.state,
      groupCampaignType: value,
    });
  }

  handleCampaignNameChanged(e, value) {
    e.preventDefault();
    this.setState({
      ...this.state,
      campaignName: value,
    });
  }

  handleAudienceSizeChanged(e, value) {
    e.preventDefault();
    this.setState({
      ...this.state,
      audienceSize: value,
    });
  }

  handleCampaignBudgetChanged(e, value) {
    e.preventDefault();
    this.setState({
      ...this.state,
      campaignBudget: value,
    });
  }

  handleClientCampaignIdChanged(e, value) {
    e.preventDefault();
    this.setState({
      ...this.state,
      clientCampaignId: value,
    });
  }

  handleOnStartMonthChange(date) {
    this.setState({
      compareStartDate: date,
    });
  }

  handleOnEndMonthChange(date) {
    this.setState({
      compareEndDate: date,
    });
  }

  handleStartDateChange(startDate) {
    this.handleChange({ startDate });
  }

  handleEndDateChange(endDate) {
    this.handleChange({ endDate });
  }

  handleChange({ startDate, endDate }) {
    startDate = startDate || this.state.startDate;
    endDate = endDate || this.state.endDate;

    if (startDate.isAfter(endDate)) {
      endDate = startDate;
      this.setState({
        compareEndDate: startDate,
      });
    }

    this.setState({
      startDate,
      endDate,
    });

    this.props.getChannelCampaigns(
      "email",
      moment(startDate).format("YYYY-MM-DD"),
      moment(endDate).format("YYYY-MM-DD"),
    );
    this.props.getChannelCampaigns(
      "social",
      moment(startDate).format("YYYY-MM-DD"),
      moment(endDate).format("YYYY-MM-DD"),
    );
    this.props.getChannelCampaigns(
      "display",
      moment(startDate).format("YYYY-MM-DD"),
      moment(endDate).format("YYYY-MM-DD"),
    );
  }

  handleClickDateWrapper() {
    let eles = document.querySelectorAll(".react-datepicker__day-name");
    // change month name
    for (const v of eles) {
      v.innerText = v.innerText.substring(0, 1);
    }
  }
  clickAddEmailCampaign(startDate, endDate) {
    this.props.getChannelCampaigns("email", startDate, endDate);
  }

  clickAddSocialCampaign(startDate, endDate) {
    this.props.getChannelCampaigns("social", startDate, endDate);
  }

  clickAddGoogleCampaign(startDate, endDate) {
    this.props.getChannelCampaigns("display", startDate, endDate);
  }

  applyChannelCampaignChanges(type, deployName, campaignIds) {
    let dataSource;
    let segmentSource;
    switch (type.toLowerCase()) {
      case "display":
        dataSource = this.state.displayDeployCampaigns;
        segmentSource = this.props.displayChannelCampaigns;
        break;
      case "social":
        dataSource = this.state.socialDeployCampaigns;
        segmentSource = this.props.socialChannelCampaigns;
        break;
      case "email":
      default:
        dataSource = this.state.emailDeployCampaigns;
        segmentSource = this.props.emailChannelCampaigns;
        break;
    }
    //const ds = filter(dataSource, (deploy) => {return deploy.name === deployName && deploy.channel.toLowerCase() === type});
    //const deployDs = ds[0].channelCampaigns;
    //const newList = filter(deployDs, ds => {return campaignIds.includes(ds.id)});
    //const toAddCid = filter(campaignIds, cid => {
    //  return filter(deployDs, ds=> {return ds.id === cid}).length <= 0
    //});
    const { campaignDetail } = this.props;
    const originDeployments =
      campaignDetail && campaignDetail.campaignDeployments
        ? filter(campaignDetail.campaignDeployments, dep => {
            return dep.channel.toLowerCase() === type;
          })
        : [];
    map(dataSource, deploy => {
      if (deploy.name === deployName && deploy.channel.toLowerCase() === type) {
        const segments = isEmpty(originDeployments)
          ? []
          : flatMap(originDeployments, "channelCampaigns");
        deploy.channelCampaigns = [];

        map(campaignIds, cid => {
          const originSegment = filter(segments, segment => {
            return segment.id === cid;
          });
          if (originSegment.length > 0) {
            deploy.channelCampaigns.push(originSegment[0]);
          } else {
            const fullSegment = filter(segmentSource, ds => {
              return ds.id === cid;
            });
            if (fullSegment.length > 0)
              deploy.channelCampaigns.push(fullSegment[0]);
          }
        });
      }
    });

    /*
    const newList = filter(dataSource, cid => campaignIds.includes(cid));
    const toAddCid = filter(campaignIds, cid => !dataSource.includes(cid));
    //const newDeployList = filter(this.state.deploymentCampaigns, (deploy))
    const result =  union(newList, toAddCid);
    let channelSelects;
    let updatedSelects;
    switch(type) {
      case "display":
        this.setState({
          sltDisplayChannelCampaigns: result
        })
        channelSelects = filter(this.props.displayChannelCampaigns, c=> result.includes(c.id));
        updatedSelects = this.props.campaignDetail ? 
          filter(filter(this.props.campaignDetail.channelCampaigns, (c) => {return c.channel ==="Display"}), 
            c=> result.includes(c.id)) : [];
        this.setState({
          selectDisplayCampaigns: union(channelSelects, updatedSelects) // channelSelects.concat(updatedSelects)
        })
        break;
      case "social":
        this.setState({
          sltSocialChannelCampaigns: result
        })
        channelSelects = filter(this.props.socialChannelCampaigns, c=> result.includes(c.id));
        updatedSelects = this.props.campaignDetail ? 
          filter(filter(this.props.campaignDetail.channelCampaigns, (c) => {return c.channel ==="Social"}), 
            c=> result.includes(c.id)) : [];
        this.setState({
          selectSocialCampaigns: union(channelSelects, updatedSelects) // channelSelects.concat(updatedSelects)
        })
        break;
      case "email":
      default:
        this.setState({
          sltEmailChannelCampaigns : result
        })
        channelSelects = filter(this.props.emailChannelCampaigns, c=> result.includes(c.id));
        updatedSelects = this.props.campaignDetail ? 
          filter(filter(this.props.campaignDetail.channelCampaigns, (c) => {return c.channel ==="Email"}), 
            c=> result.includes(c.id)) : [];
        this.setState({
          selectEmailCampaigns: union(channelSelects, updatedSelects) // channelSelects.concat(updatedSelects)
        })
        break;
    }*/
  }

  onClickCancel(e) {
    e.preventDefault();
    this.props.clearSaveCampaignErrorMessage();
    if (this.props.campaignDetail) {
      const { campaignDetail } = this.props;
      this.setState({
        campaignId: campaignDetail.id,
        startDate: moment(campaignDetail.startDate),
        compareStartDate: moment(campaignDetail.startDate),
        minStartDate: moment(campaignDetail.startDate).subtract(15, "d"),
        endDate: moment(campaignDetail.endDate),
        minEndDate: moment(campaignDetail.endDate),
        groupCampaignType: campaignDetail.type,
        compareEndDate: moment(campaignDetail.endDate),
        campaignName: campaignDetail.name,
        audienceSize: campaignDetail.audienceSize,
        campaignBudget: campaignDetail.budget,
        clientCampaignId: campaignDetail.clientCampaignId,
        selectEmailCampaigns: filter(
          campaignDetail.channelCampaigns,
          campaign => {
            return campaign.channel === "Email";
          },
        ),
        selectSocialCampaigns: filter(
          campaignDetail.channelCampaigns,
          campaign => {
            return campaign.channel === "SOCIAL";
          },
        ),
        selectDisplayCampaigns: filter(
          campaignDetail.channelCampaigns,
          campaign => {
            return campaign.channel === "Display";
          },
        ),
        inEdit: false,
        editMode: true,
        onCsvReportDownload: false,
        onPdfReportDownload: false,
        showDownloadDialog: false,
        emailDeployCampaigns: filter(
          campaignDetail.campaignDeployments,
          deployment => {
            return deployment.channel.toLowerCase() === "email";
          },
        ),
        socialDeployCampaigns: filter(
          campaignDetail.campaignDeployments,
          deployment => {
            return deployment.channel.toLowerCase() === "social";
          },
        ),
        displayDeployCampaigns: filter(
          campaignDetail.campaignDeployments,
          deployment => {
            return deployment.channel.toLowerCase() === "display";
          },
        ),
        emailReportDelivered: campaignDetail.emailReportDelivered,
        emailReportDistinctIndividuals:
          campaignDetail.emailReportDistinctIndividuals,
      });
    } else {
      this.props.history.push("/campaigns");
    }
  }

  onSaveClick(e) {
    e.preventDefault();
    const campaignData = {
      name: this.state.campaignName,
      clientId: this.props.client_id,
      startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
      endDate: moment(this.state.endDate).format("YYYY-MM-DD"),
    };

    if (this.state.campaignBudget) {
      campaignData.budget = this.state.campaignBudget;
    }
    if (this.state.audienceSize) {
      campaignData.audienceSize = this.state.audienceSize;
    }
    if (this.state.clientCampaignId) {
      campaignData.clientCampaignId = this.state.clientCampaignId;
    }
    if (this.state.campaignId) {
      campaignData.id = this.state.campaignId;
    }
    campaignData.emailReportDelivered = this.state.emailReportDelivered;
    campaignData.emailReportDistinctIndividuals = this.state.emailReportDistinctIndividuals;
    campaignData.type = this.state.groupCampaignType;
    const deployments = union(
      this.state.emailDeployCampaigns,
      this.state.socialDeployCampaigns,
      this.state.displayDeployCampaigns,
    );

    campaignData.campaignDeployments = deployments;
    /*
    map(this.state.selectEmailCampaigns, (campaign) => {
      const obj = {id: campaign.id};
      campaignData.channelCampaigns.push(obj);
    })
    map(this.state.selectSocialCampaigns, (campaign) => {
      const obj = {id: campaign.id};
      campaignData.channelCampaigns.push(obj);
    })
    map(this.state.selectDisplayCampaigns, (campaign) => {
      const obj = {id: campaign.id}
      campaignData.channelCampaigns.push(obj);
    })*/

    this.props.saveCampaignGroup(campaignData);
  }

  onEditClick(e) {
    e.preventDefault();
    this.setState({
      inEdit: true,
      editMode: false,
    });
  }

  intKeyDown(evt) {
    var key = evt.charCode || evt.keyCode || 0;
    if (
      !(
        key === 8 ||
        key === 9 ||
        key === 46 ||
        key === 110 ||
        (key >= 35 && key <= 40) ||
        (key >= 48 && key <= 57) ||
        (key >= 96 && key <= 105)
      )
    ) {
      evt.preventDefault();
    }
  }

  numKeyDown(evt) {
    var key = evt.charCode || evt.keyCode || 0;
    if (
      !(
        key === 8 ||
        key === 9 ||
        key === 46 ||
        key === 110 ||
        key === 190 ||
        (key >= 35 && key <= 40) ||
        (key >= 48 && key <= 57) ||
        (key >= 96 && key <= 105)
      )
    ) {
      evt.preventDefault();
    }
  }

  handleBudgetOnBlur(e, val) {
    e.preventDefault();
    /*
    this.setState({
      campaignBudget: "$" + val
    })
    console.log(this.state.campaignBudget)*/
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.client_id !== this.props.client_id && this.props.client_id) {
      //this.props.history.push("/campaigns")
      this.props.selectClient(this.props.campaignDetail.clientId);
    }

    if (nextProps.client_tz !== this.props.client_tz) {
      moment.tz.setDefault(nextProps.client_tz);

      const {
        startDate,
        endDate,
        compareStartDate,
        compareEndDate,
      } = this.state;
      if (nextProps.client_tz) {
        this.setState({
          startDate: getTimezoneMoment(moment(startDate), nextProps.client_tz),
          compareStartDate: getTimezoneMoment(
            moment(compareStartDate),
            nextProps.client_tz,
          ),
          minStartDate: getTimezoneMoment(
            moment(compareStartDate),
            nextProps.client_tz,
          ).subtract(15, "d"),
          endDate: getTimezoneMoment(moment(endDate), nextProps.client_tz),
          compareEndDate: getTimezoneMoment(
            moment(compareEndDate),
            nextProps.client_tz,
          ),
        });
      }
    }
    if (!isEqual(nextProps.campaignDetail, this.props.campaignDetail)) {
      if (nextProps.campaignDetail) {
        const { campaignDetail } = nextProps;
        const selectEmailCampaigns = filter(
          campaignDetail.channelCampaigns,
          campaign => {
            return campaign.channel === "Email";
          },
        );
        const selectSocialCampaigns = filter(
          campaignDetail.channelCampaigns,
          campaign => {
            return campaign.channel === "SOCIAL";
          },
        );
        const selectDisplayCampaigns = filter(
          campaignDetail.channelCampaigns,
          campaign => {
            return campaign.channel === "Display";
          },
        );
        this.setState({
          campaignId: nextProps.campaignDetail.id,
          startDate: getTimezoneMoment(
            campaignDetail.startDate,
            nextProps.client_tz,
          ),
          compareStartDate: getTimezoneMoment(
            campaignDetail.startDate,
            nextProps.client_tz,
          ),
          minStartDate: getTimezoneMoment(
            campaignDetail.startDate,
            nextProps.client_tz,
          ),
          endDate: getTimezoneMoment(
            campaignDetail.endDate,
            nextProps.client_tz,
          ),
          compareEndDate: getTimezoneMoment(
            campaignDetail.endDate,
            nextProps.client_tz,
          ),
          campaignName: campaignDetail.name,
          audienceSize: campaignDetail.audienceSize,
          campaignBudget: campaignDetail.budget,
          clientCampaignId: campaignDetail.clientCampaignId,
          selectEmailCampaigns: selectEmailCampaigns,
          selectSocialCampaigns: selectSocialCampaigns,
          selectDisplayCampaigns: selectDisplayCampaigns,
          sltEmailChannelCampaigns: map(selectEmailCampaigns, "id"),
          sltSocialChannelCampaigns: map(selectSocialCampaigns, "id"),
          sltDisplayChannelCampaigns: map(selectDisplayCampaigns, "id"),
          emailDeployCampaigns: campaignDetail.emailDeployments,
          socialDeployCampaigns: campaignDetail.socialDeployments,
          displayDeployCampaigns: campaignDetail.displayDeployments,
          emailReportDelivered: campaignDetail.emailReportDelivered,
          emailReportDistinctIndividuals:
            campaignDetail.emailReportDistinctIndividuals,
        });
      }
    }

    if (this.props.client_id !== nextProps.client_id) {
      if (this.props.campaignDetail) {
        if (nextProps.client_id !== this.props.campaignDetail.clientId) {
          this.props.selectClient(this.props.campaignDetail.clientId);
        }
      }
    }
  }
  componentDidMount() {
    const datePickers = document.getElementsByClassName(
      "react-datepicker__input-container",
    );
    map(datePickers, datePicker => {
      datePicker.childNodes[0].setAttribute("readOnly", true);
    });

    const { match, location } = this.props;
    if (location.pathname.indexOf("campaigns/edit") >= 0) {
      if (match && match.params && match.params.id) {
        this.setState({
          campaignId: match.params.id,
          inEdit: false,
          editMode: true,
        });
        if (!this.props.campaignDetail) {
          this.props.getCampaignById(match.params.id);
        }
      }
    }
  }

  handleClickDownload() {
    this.setState({ showDownloadDialog: true });
  }

  handleDownload(e) {
    e.preventDefault();

    if (this.refs.cbPDF.state.switched) {
      this.handlePdfDownload();
    }

    if (this.refs.cbCSV.state.switched) {
      this.handleCsvDownload();
    }
  }
  _addPdfHeader(pdf, client_name, bu_name, campaignDetail) {
    pdf.setFillColor(127, 127, 127);
    pdf.rect(0, 15, 210, 10, "F");

    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(9);
    pdf.setFontType("bold");
    pdf.addImage(pdfReportHeaderDataUri(), "PNG", 10.5, 3, 60, 0);
    pdf.text(198, 8, moment().format("MMMM DD, YYYY"), null, null, "right");

    pdf.setTextColor(255, 255, 255);
    pdf.setFontType("bold");
    pdf.text(12, 21, "Client:");
    //const lenClientName = getTextSize(client_name.trim(), 'helvetica')
    pdf.setFontType("normal");
    pdf.text(26, 21, client_name ? client_name.trim() : "");
    //cm to inches
    let start = 90; //46 + lenClientName.width * 0.3937 + 0.4
    if (!isEmpty(bu_name)) {
      pdf.setFontType("bold");
      pdf.text(start, 21, "Business Unit:");
      start += 26.5;
      pdf.setFontType("normal");
      pdf.text(start, 21, bu_name ? bu_name.trim() : "");
    }
    pdf.setFillColor(255);
    start = 12;
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(10);
    pdf.text(12, 30, "Campaigns  >  " + campaignDetail.name);
  }
  handlePdfDownload() {
    this.setState({ onPdfReportDownload: true, showDownloadDialog: false });
    const { campaignDetail, clients, client_info } = this.props;
    let client_name = client_info.name;
    let bu_name = "";
    if (client_info.parentClientId) {
      const c = find(clients, c => {
        return c.id === client_info.parentClientId;
      });
      client_name = c.name;
      bu_name = client_info.name;
    }

    const pdfFileName =
      campaignDetail.name.split(" ").join("_") +
      "_Campaign_Group_Details_" +
      moment().format("YYYYMMDD") +
      ".pdf";

    const pdf = new pdfConverter("p", "mm", "a4");
    pdf.setFont("Helvetica");
    pdf.setFontType("normal");
    pdf.setFontSize(9);
    const pageWidth = 186;

    const el_campaign_detail = document.getElementsByClassName(
      "campaign-detail-pdf-container",
    )[0];
    el_campaign_detail.style.display = "block";
    const el_email_channel = document.getElementsByClassName(
      "email-channel-section",
    )[0];
    const el_social_channel = document.getElementsByClassName(
      "social-channel-section",
    )[0];
    const el_display_channel = document.getElementsByClassName(
      "display-channel-section",
    )[0];
    const el_arrow_down_icons = document.getElementsByClassName("arrow-down");
    map(el_arrow_down_icons, icon => {
      icon.style.display = "none";
    });
    const tables = document.getElementsByClassName("spread-table");
    for (var i = 0; i < tables.length; i++) {
      tables[i].style.maxHeight = "450px";
    }

    let canvasCampaignDetail = null;
    let canvasEmailChannel = null;
    let canvasFacebookChannel = null;
    let canvasGoogleChannel = null;
    let isCanvasCampaignDetailReady = false;
    let isCanvasEmailChannelReady = false;
    let isCanvasFacebookChannelReady = false;
    let isCanvasGoogleChannelReady = false;

    const oriWidth = el_campaign_detail.offsetWidth;
    el_campaign_detail.style.width = "1024px";
    el_email_channel.style.width = "1024px";
    el_social_channel.style.width = "1024px";
    el_display_channel.style.width = "1024px";

    setTimeout(function() {
      html2canvas(el_campaign_detail, { logging: false }).then(function(
        canvas,
      ) {
        canvasCampaignDetail = canvas;
        isCanvasCampaignDetailReady = true;
        el_campaign_detail.style.width = oriWidth + "px";
        el_campaign_detail.style.display = "none";
      });
    }, 50);
    setTimeout(function() {
      html2canvas(el_email_channel, { logging: false }).then(function(canvas) {
        canvasEmailChannel = canvas;
        isCanvasEmailChannelReady = true;
        el_email_channel.style.width = oriWidth + "px";
      });
    }, 50);
    setTimeout(function() {
      html2canvas(el_social_channel, { logging: false }).then(function(canvas) {
        canvasFacebookChannel = canvas;
        isCanvasFacebookChannelReady = true;
        el_social_channel.style.width = oriWidth + "px";
      });
    }, 50);
    setTimeout(function() {
      html2canvas(el_display_channel, { logging: false }).then(function(
        canvas,
      ) {
        canvasGoogleChannel = canvas;
        isCanvasGoogleChannelReady = true;
        el_display_channel.style.width = oriWidth + "px";
      });
    }, 50);

    let top = 35;
    const left = 12;
    let intervalId = setInterval(
      function() {
        if (
          isCanvasCampaignDetailReady === false ||
          isCanvasEmailChannelReady === false ||
          isCanvasFacebookChannelReady === false ||
          isCanvasGoogleChannelReady === false
        ) {
          console.log("PDF Generating...");
        } else {
          clearInterval(intervalId);
          setTimeout(
            function() {
              this._addPdfHeader(pdf, client_name, bu_name, campaignDetail);
              const h1 =
                (canvasCampaignDetail.height * pageWidth) /
                canvasCampaignDetail.width;
              const h2 =
                (canvasEmailChannel.height * pageWidth) /
                canvasEmailChannel.width;
              const h3 =
                (canvasFacebookChannel.height * pageWidth) /
                canvasFacebookChannel.width;
              const h4 =
                (canvasGoogleChannel.height * pageWidth) /
                canvasGoogleChannel.width;

              pdf.addImage(
                canvasCampaignDetail.toDataURL(),
                "PNG",
                left,
                top,
                pageWidth,
                0,
              );
              top += h1 + 4;
              pdf.addImage(
                canvasEmailChannel.toDataURL(),
                "PNG",
                left,
                top,
                pageWidth,
                0,
              );
              top += h2 + 4;

              if (top + h3 > 285) {
                addPdfFooter(pdf);
                pdf.addPage("a4", "p");
                this._addPdfHeader(pdf, client_name, bu_name, campaignDetail);
                top = 35;
              }
              pdf.addImage(
                canvasFacebookChannel.toDataURL(),
                "PNG",
                left,
                top,
                pageWidth,
                0,
              );
              top += h3 + 4;

              if (top + h4 > 285) {
                addPdfFooter(pdf);
                pdf.addPage("a4", "p");
                this._addPdfHeader(pdf, client_name, bu_name, campaignDetail);
                top = 35;
              }
              pdf.addImage(
                canvasGoogleChannel.toDataURL(),
                "PNG",
                left,
                top,
                pageWidth,
                0,
              );

              map(el_arrow_down_icons, icon => {
                icon.style.display = "block";
              });

              addPdfFooter(pdf);

              for (var i = 0; i < tables.length; i++) {
                tables[i].style.maxHeight = "320px";
              }

              pdf.save(pdfFileName);
              this.setState({ onPdfReportDownload: false });
            }.bind(this),
            100,
          );
        }
      }.bind(this),
      50,
    );
  }
  handleCsvDownload() {
    this.setState({ onCsvReportDownload: true, showDownloadDialog: false });

    const { campaignDetail, clients, client_info } = this.props;
    let client_name = client_info.name;
    let bu_name = "";
    if (client_info.parentClientId) {
      const c = find(clients, c => {
        return c.id === client_info.parentClientId;
      });
      client_name = c.name;
      bu_name = client_info.name;
    }
    const budget = "$" + formatMoney(campaignDetail.budget, 2, ".", ",");
    let title_line = "AudienceAnywhere Campaign Group Details Report ,,,,\r\n";
    // moment().format("YYYY-MM-DD")
    let date_line =
      "Today's Date," + `"${moment().format("MM/DD/YY")}"` + ",,,\r\n";
    let client_line = "Client," + client_name + ",,,\r\n";
    let business_unit_line = "Business Unit," + bu_name + ",,,\r\n";
    const split_line = ",,,,\r\n";
    const campaign_group_line = "CAMPAIGN GROUP,,,,\r\n";
    const campaign_group_name_line = `Campaign Group Name,${campaignDetail.name},,,\r\n`;
    const campaign_group_audience_line = `Audience Size,"${campaignDetail.audienceSize}",,,\r\n`;
    const campaign_group_budget_line = `Campaign Budget,"${budget} ",,,\r\n`;
    const campaign_group_id_line = `Campaign Group ID,"${campaignDetail.campaignId}",,,\r\n`;
    const campaign_group_client_group_id_line = `Client Campaign ID,${campaignDetail.clientCampaignId},,,\r\n`;
    const campaign_group_start_date_line = `Campaign Group Start Date,${moment(
      campaignDetail.startDate,
      "YYYY-MM-DD",
    ).format("MM-DD-YYYY")},,,\r\n`;
    const campaign_group_end_date_line = `Campaign Group End Date,${
      campaignDetail.endDate
        ? moment(campaignDetail.endDate, "YYYY-MM-DD").format("MM-DD-YYYY")
        : ""
    },,,\r\n`;
    const campaign_group_status_line = `Campaign Group Status,${campaignDetail.status},,,\r\n`;
    const email_title_line = "EMAIL,,,,\r\n";
    const campaign_reporting_options = `Reporting Options,${
      campaignDetail.emailReportDelivered
        ? "Delivered"
        : campaignDetail.emailReportDistinctIndividuals
        ? "Distinct Individuals"
        : ""
    },,,\r\n`;
    const email_channel_campaign_lines = [];
    const social_channel_campaign_lines = [];
    const display_channel_campaign_lines = [];
    let email_deployment_idx = 0;
    let social_deployment_id = 0;
    let display_deployment_id = 0;
    function formatSpecialSymbol(str) {
      if (!str || typeof str !== "string") return str;
      else return str.replace(/#/g, "♯");
    }
    map(campaignDetail.campaignDeployments, (deployment, idx) => {
      let line = "";

      if (deployment.channel.toLowerCase() === "email") {
        line += ",,,,\r\n";
        line += `Deployment ${email_deployment_idx + 1} - ${
          deployment.name
        },,,,\r\n`;
        email_deployment_idx += 1;
        line += `Segment Name,Segment ID,Segment Start Date,Segment End Date,Status\r\n`;
        map(deployment.channelCampaigns, campaign => {
          line += `${formatSpecialSymbol(campaign.name)},"${
            campaign.campaignId
          }",${moment(campaign.startDate, "YYYY-MM-DD").format("MM-DD-YYYY")},${
            campaign.endDate
              ? moment(campaign.endDate, "YYYY-MM-DD").format("MM-DD-YYYY")
              : ""
          },${campaign.status}\r\n`;
        });
        email_channel_campaign_lines.push(line);
      }
      if (deployment.channel.toLowerCase() === "social") {
        line += ",,,,\r\n";
        line += `Deployment ${social_deployment_id + 1} - ${
          deployment.name
        },,,,\r\n`;
        social_deployment_id += 1;
        line += `Segment Name,Segment ID,Segment Start Date,Segment End Date,Status\r\n`;
        map(deployment.channelCampaigns, campaign => {
          line += `${formatSpecialSymbol(campaign.name)},"${
            campaign.campaignId
          }",${moment(campaign.startDate, "YYYY-MM-DD").format("MM-DD-YYYY")},${
            campaign.endDate
              ? moment(campaign.endDate, "YYYY-MM-DD").format("MM-DD-YYYY")
              : ""
          },${campaign.status}\r\n`;
        });
        social_channel_campaign_lines.push(line);
      }
      if (deployment.channel.toLowerCase() === "display") {
        line += ",,,,\r\n";
        line += `Deployment ${display_deployment_id + 1} - ${
          deployment.name
        },,,,\r\n`;
        display_deployment_id += 1;
        line += `Segment Name,Segment ID,Segment Start Date,Segment End Date,Status\r\n`;
        map(deployment.channelCampaigns, campaign => {
          line += `${formatSpecialSymbol(campaign.name)},"${
            campaign.campaignId
          }",${moment(campaign.startDate, "YYYY-MM-DD").format("MM-DD-YYYY")},${
            campaign.endDate
              ? moment(campaign.endDate, "YYYY-MM-DD").format("MM-DD-YYYY")
              : ""
          },${campaign.status}\r\n`;
        });
        display_channel_campaign_lines.push(line);
      }
    });
    const social_title_line = `SOCIAL,,,,\r\n`;
    const facebook_title_line = `FACEBOOK,,,,\r\n`;
    const display_title_line = `DISPLAY,,,,\r\n`;
    const google_table_header_line = "";
    const facebook_table_header_line = "";
    const google_title_line = `Google Ads,,,,\r\n`;
    let resultString =
      title_line +
      date_line +
      client_line +
      business_unit_line +
      split_line +
      campaign_group_line +
      campaign_group_name_line +
      campaign_group_audience_line +
      campaign_group_budget_line +
      campaign_group_id_line +
      campaign_group_client_group_id_line +
      campaign_group_start_date_line +
      campaign_group_end_date_line +
      campaign_group_status_line +
      split_line +
      email_title_line;
    if (
      campaignDetail.emailReportDelivered ||
      campaignDetail.emailReportDistinctIndividuals
    ) {
      resultString += campaign_reporting_options;
    }
    map(email_channel_campaign_lines, line => {
      resultString += line;
    });
    resultString +=
      split_line + social_title_line + split_line + facebook_title_line;
    if (social_channel_campaign_lines.length > 0) {
      resultString += facebook_table_header_line;
      map(social_channel_campaign_lines, line => {
        resultString += line;
      });
    }

    resultString +=
      split_line + display_title_line + split_line + google_title_line;
    if (display_channel_campaign_lines.length > 0) {
      resultString += google_table_header_line;
      map(display_channel_campaign_lines, line => {
        resultString += line;
      });
    }
    const csvFileName =
      campaignDetail.name.split(" ").join("_") +
      "_Campaign_Group_Details_" +
      moment().format("YYYYMMDD");

    downLoadCSVFunc(resultString, csvFileName);
    setTimeout(
      function() {
        this.setState({ onCsvReportDownload: false });
      }.bind(this),
      2000,
    );
  }

  addDeployment(name, channel) {
    let result;
    switch (channel.toUpperCase()) {
      case "SOCIAL":
        result = this.state.socialDeployCampaigns;
        break;
      case "DISPLAY":
        result = this.state.displayDeployCampaigns;
        break;
      case "EMAIL":
      default:
        result = this.state.emailDeployCampaigns;
        break;
    }
    result.push({
      name: name,
      channel: channel,
      channelCampaigns: [],
    });
    switch (channel.toUpperCase()) {
      case "SOCIAL":
        this.setState({
          socialDeployCampaigns: result,
        });
        break;
      case "DISPLAY":
        this.setState({
          displayDeployCampaigns: result,
        });
        break;
      case "EMAIL":
      default:
        this.setState({
          emailDeployCampaigns: result,
        });
        break;
    }
  }

  removeDeployment(name, channel) {
    let source;
    switch (channel) {
      case "social":
        source = this.state.socialDeployCampaigns;
        break;
      case "display":
        source = this.state.displayDeployCampaigns;
        break;
      case "email":
      default:
        source = this.state.emailDeployCampaigns;
        break;
    }
    remove(source, deployment => {
      return (
        deployment.name.toLowerCase() === name.toLowerCase() &&
        deployment.channel.toLowerCase() === channel.toLowerCase()
      );
    });
    /*
    this.setState({
      deploymentCampaigns: result
    })*/
  }

  setEmailReportDelivered(val) {
    this.setState({
      emailReportDelivered: val,
    });
  }

  setEmailReportDistinct(val) {
    this.setState({
      emailReportDistinctIndividuals: val,
    });
  }

  render() {
    const {
      savingCampaignErrorMessage,
      onSavingCampaign,
      campaignDetail,
    } = this.props;
    return (
      <div className="create-campaigns date-selection">
        <BreadCrumb
          selected_client={this.props.client_id}
          crumb={campaignDetail ? campaignDetail.name : "Create Campaign"}
          linkName="Campaigns"
          showDownloadBtn={campaignDetail && !this.state.inEdit ? true : false}
          handleDownload={this.handleClickDownload.bind(this)}
        />
        {this.state.inEdit ? (
          <div className="group">
            <h2 style={{ fontSize: "24px", maginBottom: "20px" }}>
              CAMPAIGN GROUP
            </h2>
            <InputField
              labelTitle="Campaign Group Name"
              key="campaign-name-input-field"
              onChange={(e, value) => this.handleCampaignNameChanged(e, value)}
              labelStyle={{
                float: "left",
                height: "33px",
                lineHeight: "33px",
                margin: 0,
                fontSize: "16px",
                fontWeight: "bold",
              }}
              inputContainerClassName="input-wrapper"
              inputStyle={{ height: "28px", fontSize: "16px" }}
              initValue={this.state.campaignName}
              borderColor="#EEEFF2"
              ifRequireField={true}
            />
            <section className="group-type-container">
              <p style={{ width: "396px", float: "left", fontSize: "16px" }}>
                Campaign Group Type
              </p>
              <span>
                <RadioButtonGroup
                  style={{ float: "left", width: "40%" }}
                  name="campaignType"
                  valueSelected={this.state.groupCampaignType}
                  onChange={(e, value) =>
                    this.handleGroupCampaignTypeChange(e, value)
                  }
                >
                  <RadioButton
                    value={"General"}
                    label="General Marketing Campaign"
                    iconStyle={{ fill: "black", width: "20px", height: "20px" }}
                  />
                  <RadioButton
                    value={"FirmOfferOfCredit"}
                    label="Firm Offer Of Credit"
                    iconStyle={{ fill: "black", width: "20px", height: "20px" }}
                  />
                </RadioButtonGroup>
              </span>
            </section>
            <InputField
              key="audience-size-input-field"
              labelTitle="Audience Size"
              labelStyle={{
                float: "left",
                height: "33px",
                lineHeight: "33px",
                margin: 0,
                fontSize: "16px",
                fontWeight: "bold",
              }}
              inputContainerClassName="input-wrapper"
              onChange={(e, value) => this.handleAudienceSizeChanged(e, value)}
              inputStyle={{ height: "28px", fontSize: "16px" }}
              initValue={this.state.audienceSize}
              onKeyDown={this.intKeyDown}
              borderColor="#EEEFF2"
              maskInput={val => {
                return splitNumber(val)();
              }}
            />
            <InputField
              key="campaign-budget-input-field"
              labelTitle="Campaign Budget"
              labelStyle={{
                float: "left",
                height: "33px",
                lineHeight: "33px",
                margin: 0,
                fontSize: "16px",
                fontWeight: "bold",
              }}
              onChange={(e, value) =>
                this.handleCampaignBudgetChanged(e, value)
              }
              inputContainerClassName="input-wrapper"
              inputStyle={{ height: "28px", fontSize: "16px" }}
              handleOnBlur={this.handleBudgetOnBlur.bind(this)}
              initValue={this.state.campaignBudget}
              onKeyDown={this.numKeyDown}
              maskInput={val => {
                return "$" + formatMoney(val, 2, ".", ",");
              }}
              borderColor="#EEEFF2"
            />
            <section className="cam-id">
              <span>
                # Campaign Group ID<em>*</em>
              </span>
              {this.props.campaignDetail ? (
                <span>{this.props.campaignDetail.campaignId}</span>
              ) : (
                <strong>-</strong>
              )}
            </section>
            <InputField
              key="client-campaign-id-input-field"
              labelTitle="Client Campaign ID"
              labelStyle={{
                float: "left",
                height: "33px",
                lineHeight: "33px",
                margin: 0,
                fontSize: "16px",
                fontWeight: "bold",
              }}
              inputContainerClassName="input-wrapper"
              onChange={(e, value) =>
                this.handleClientCampaignIdChanged(e, value)
              }
              inputStyle={{ height: "28px", fontSize: "16px" }}
              initValue={this.state.clientCampaignId}
              borderColor="#EEEFF2"
            />
            <section
              className="startDate content clearfix"
              style={{ marginBottom: "30px" }}
            >
              <span className="title" style={{ fontSize: "16px" }}>
                Campaign Group Start Date<em>*</em>
              </span>
              <div
                className="start-date clearfix"
                style={{
                  borderColor:
                    /*this.state.selectEmailCampaigns.length > 0 ? "#D3D3D3" :*/ "#EEEFF2",
                }}
              >
                <div
                  className="icon-wrapper"
                  style={{
                    background:
                      /*this.state.selectEmailCampaigns.length > 0 ? "#D3D3D3" : */ "#F6F6F6",
                  }}
                >
                  <i
                    className="far fa-calendar-alt"
                    style={{
                      color:
                        /*this.state.selectEmailCampaigns.length > 0 ? "#999999" :*/ "#A3A3A3",
                    }}
                  />
                </div>
                <div
                  className="date-wrapper"
                  onClick={() => this.handleClickDateWrapper()}
                >
                  <DatePicker
                    dateFormat="MM-DD-YYYY"
                    calendarClassName="calendar-left"
                    className={
                      /*this.state.selectEmailCampaigns.length > 0 ? "date-con date-con-disabled" :*/ "date-con"
                    }
                    selected={this.state.startDate}
                    startDate={this.state.startDate}
                    minDate={
                      this.state.minStartDate
                    } /*
                  disabled={(this.state.selectEmailCampaigns && this.state.selectEmailCampaigns.length > 0) || 
                    (this.state.selectSocialCampaigns && this.state.selectSocialCampaigns.length > 0) || 
                    (this.state.selectDisplayCampaigns && this.state.selectDisplayCampaigns.length > 0)}*/
                    filterDate={date =>
                      date.format("M") ===
                      this.state.compareStartDate.format("M")
                    }
                    onMonthChange={date => this.handleOnStartMonthChange(date)}
                    onChange={date => this.handleStartDateChange(date)}
                    showDisabledMonthNavigation
                  />
                </div>
              </div>
              <br />
              {/*
              ((this.state.selectEmailCampaigns.length > 0) || (this.state.selectDisplayCampaigns.length > 0) || 
              (this.state.selectSocialCampaigns.length > 0)) && (
            <div style={{marginLeft:'32%'}}>   
              <div style={{fontWeight:'normal', fontStyle:'italic', lineHeight:'18px', marginTop:'10px'}}
                ><strong>Note</strong>: Start date can not be changed while channel campaigns<br /> 
                        <span style={{width:'20px', height:'18px'}} />are associated to it.
              </div>
              </div>)*/}
            </section>
            <section className="startDate clearfix">
              <span className="title">
                Campaign Group End Date<em>*</em>
              </span>
              <div
                className="start-date content clearfix"
                style={{ borderColor: "#EEEFF2" }}
              >
                <div className="icon-wrapper" style={{ background: "#F6F6F6" }}>
                  <i
                    className="far fa-calendar-alt"
                    style={{ color: "#A3A3A3" }}
                  />
                </div>
                <div
                  className="date-wrapper"
                  onClick={() => this.handleClickDateWrapper()}
                >
                  <DatePicker
                    dateFormat="MM-DD-YYYY"
                    calendarClassName="calendar-left"
                    className="date-con"
                    selected={this.state.endDate}
                    endDate={this.state.endDate}
                    filterDate={date =>
                      date.format("M") === this.state.compareEndDate.format("M")
                    }
                    onMonthChange={date => this.handleOnEndMonthChange(date)}
                    onChange={date => this.handleEndDateChange(date)}
                    minDate={
                      this.props.campaignDetail &&
                      this.props.campaignDetail.status.toLowerCase !==
                        "draft" &&
                      this.props.campaignDetail.campaignDeployments.length > 0
                        ? moment(this.props.campaignDetail.endDate)
                        : this.state.startDate
                    }
                    showDisabledMonthNavigation
                  />
                </div>
              </div>
            </section>
            <section className="cam-id" style={{ margin: 0 }}>
              <span>Campaign Group Status</span>
              {this.props.campaignDetail ? (
                <span>{this.props.campaignDetail.status}</span>
              ) : (
                <strong>-</strong>
              )}
            </section>
          </div>
        ) : (
          campaignDetail && <CampaignDetail data={campaignDetail} />
        )}
        <div className="add email-channel-section">
          <AddCampaign
            title="EMAIL"
            startDate={moment(this.state.startDate).format("YYYY-MM-DD")}
            endDate={moment(this.state.endDate).format("YYYY-MM-DD")}
            campaignName={this.state.campaignName}
            parentCampaignDetail={this.props.campaignDetail}
            selectedCampaigns={this.state.selectEmailCampaigns}
            channelCampaigns={this.props.emailChannelCampaigns}
            prevSelectCampaignIds={this.state.sltEmailChannelCampaigns}
            onClickAddCampaign={this.clickAddEmailCampaign.bind(this)}
            onApplyCampaignChanges={this.applyChannelCampaignChanges.bind(this)}
            viewMode={!this.state.inEdit}
            showReportOptions={true}
            setEmailReportDelivered={this.setEmailReportDelivered.bind(this)}
            setEmailReportDistinct={this.setEmailReportDistinct.bind(this)}
            deploymentCampaigns={this.state.emailDeployCampaigns}
            addDeployment={this.addDeployment.bind(this)}
            removeDeployment={this.removeDeployment.bind(this)}
          />
        </div>
        <div className="add social-channel-section">
          <AddCampaign
            title="SOCIAL"
            startDate={moment(this.state.startDate).format("YYYY-MM-DD")}
            endDate={moment(this.state.endDate).format("YYYY-MM-DD")}
            campaignName={this.state.campaignName}
            parentCampaignDetail={this.props.campaignDetail}
            selectedCampaigns={this.state.selectSocialCampaigns}
            channelCampaigns={this.props.socialChannelCampaigns}
            prevSelectCampaignIds={this.state.sltSocialChannelCampaigns}
            onClickAddCampaign={this.clickAddSocialCampaign.bind(this)}
            onApplyCampaignChanges={this.applyChannelCampaignChanges.bind(this)}
            viewMode={!this.state.inEdit}
            showReportOptions={false}
            deploymentCampaigns={this.state.socialDeployCampaigns}
            addDeployment={this.addDeployment.bind(this)}
            removeDeployment={this.removeDeployment.bind(this)}
            legacy={false}
          >
            <h3>FACEBOOK</h3>
          </AddCampaign>
        </div>
        <div className="add display-channel-section">
          <AddCampaign
            title="DISPLAY"
            startDate={moment(this.state.startDate).format("YYYY-MM-DD")}
            endDate={moment(this.state.endDate).format("YYYY-MM-DD")}
            campaignName={this.state.campaignName}
            parentCampaignDetail={this.props.campaignDetail}
            selectedCampaigns={this.state.selectDisplayCampaigns}
            channelCampaigns={this.props.displayChannelCampaigns}
            prevSelectCampaignIds={this.state.sltDisplayChannelCampaigns}
            onClickAddCampaign={this.clickAddGoogleCampaign.bind(this)}
            onApplyCampaignChanges={this.applyChannelCampaignChanges.bind(this)}
            viewMode={!this.state.inEdit}
            deploymentCampaigns={this.state.displayDeployCampaigns}
            addDeployment={this.addDeployment.bind(this)}
            removeDeployment={this.removeDeployment.bind(this)}
            legacy={false}
          >
            <h3>Google Ads</h3>
          </AddCampaign>
        </div>
        <div className="create-btn clearfix">
          {this.state.inEdit ? (
            <div>
              <div className="confirm">
                <Button
                  title="Save"
                  disabled={!this.state.campaignName}
                  handleClick={this.onSaveClick.bind(this)}
                />
              </div>
              <div className="confirm">
                <Button
                  ifHasBg={false}
                  handleClick={this.onClickCancel.bind(this)}
                  title="Cancel"
                />
              </div>
            </div>
          ) : (
            <div className="confirm">
              <Button title="Edit" handleClick={this.onEditClick.bind(this)} />
            </div>
          )}

          <div className="cancel pt-5">
            {onSavingCampaign && (
              <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
            )}
            {savingCampaignErrorMessage && (
              <span style={{ color: "#FF0000" }}>
                <i className="icon-warning2 pr-10" />
                {savingCampaignErrorMessage}
              </span>
            )}
          </div>
        </div>
        <Dialog
          open={this.state.onCsvReportDownload}
          style={{ top: "-1.8em" }}
          modal={true}
          contentStyle={{ width: "500px" }}
          overlayStyle={{ opacity: 0.9, backgroundColor: "#666666" }}
        >
          <Row className="mt-20">
            <Col
              offsetXs="1"
              offsetSm="1"
              offsetMd="1"
              offsetLg="1"
              xs="7"
              sm="7"
              md="7"
              lg="7"
              className="text-right"
            >
              <div>{"Downloading, please wait..."}</div>
            </Col>
            <Col xs="1" sm="1" md="1" lg="1">
              <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
            </Col>
          </Row>
        </Dialog>
        <Dialog
          open={this.state.onPdfReportDownload}
          style={{ top: "-1.8em" }}
          modal={true}
          contentStyle={{ width: "500px" }}
          overlayStyle={{ opacity: 0.9, backgroundColor: "#666666" }}
        >
          <Row className="mt-20">
            <Col
              offsetXs="1"
              offsetSm="1"
              offsetMd="1"
              offsetLg="1"
              xs="7"
              sm="7"
              md="7"
              lg="7"
              className="text-right"
            >
              <div>{"Downloading, please wait..."}</div>
            </Col>
            <Col xs="1" sm="1" md="1" lg="1">
              <img alt="" src="/Spinner.gif" style={{ height: "24px" }} />
            </Col>
          </Row>
        </Dialog>
        <Dialog
          open={this.state.showDownloadDialog}
          style={{ top: "-1.8em" }}
          modal={true}
          contentStyle={{ width: "440px" }}
        >
          <FullRow
            className="no-margin-top no-padding"
            style={{ fontSize: "16px", color: "#000" }}
          >
            <strong>Choose the type of file you would like to download</strong>
          </FullRow>
          <FullRow
            className="no-padding-top no-padding-right no-padding-bottom no-margin-bottom"
            style={{ paddingLeft: "150px" }}
          >
            <Checkbox
              iconStyle={{ fill: "#47A1AB", marginRight: "10px" }}
              label={"PDF File"}
              labelStyle={{ fontSize: "16px" }}
              defaultChecked={false}
              ref="cbPDF" /*onCheck={this.updateCheck.bind(this, item.id)}*/
            />
          </FullRow>
          <FullRow
            className="no-padding-top no-padding-right no-padding-bottom"
            style={{ paddingLeft: "150px" }}
          >
            <Checkbox
              iconStyle={{ fill: "#47A1AB", marginRight: "10px" }}
              label={"CSV File"}
              labelStyle={{ fontSize: "16px" }}
              defaultChecked={true}
              ref="cbCSV" /*onCheck={this.updateCheck.bind(this, item.id)}*/
            />
          </FullRow>
          <FullRow className="no-padding no-margin-bottom mt-20 text-center">
            <button
              type="button"
              onClick={() => this.setState({ showDownloadDialog: false })}
              className="btn btn-default btn-aa-info mr-20"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={this.handleDownload.bind(this)}
              className="btn btn-default btn-aa-default"
            >
              Download File
            </button>
          </FullRow>
        </Dialog>
      </div>
    );
  }
}

export default CreateCampaigns;



// WEBPACK FOOTER //
// ./src/components/Campaigns/CreateCampaigns/CreateCampaigns.jsx